import React from 'react'

import { RedocStandalone } from 'redoc';

import "./API.scss"

function API() {
  return (
    <div className="honey-api">
      <RedocStandalone specUrl="/docs/swagger.json"/>
    </div>
  );
}

export default API;
